import React from 'react';
import { Genealogy } from './Genealogy';

export const TreeTeamView = ({
  response,
  isTree,
  searchNode,
  handleSentData,
  reloadData,
  setTreeGroup,
  setopenAddDialog,
  ChartType,
}) => (
  <>
    <div className='TreeTeamViewTreeView'>
      {response && response.filter && (
        <div className='treePaper'>
          <div className='Teamgenealogy-tree'>
            <div
              className={`genealogy-tree ${ChartType && ChartType === 'filetree' ? 'filetree' : ''}   `}
            >
              <ul
                className={`wtree ${response && response.length > 2 ? 'more' : 'sub'}   ${ChartType && ChartType === 'filetree' ? 'filetree' : 'sub'}   `}
              >
                {response
                .filter((item) => item.businessGroupsParentId === null)
                .map((node, i) => (
                  <Genealogy
                    key={i}
                    isVisible
                    Parent={node}
                    isTree={isTree}
                    response={response}
                    searchNode={searchNode}
                    handleSentData={handleSentData}
                    reloadData={() => reloadData()}
                    setTreeGroup={(x) => setTreeGroup(x)}
                    setopenAddDialog={() => setopenAddDialog()}
                    ChartType={ChartType}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  </>
);
